import React from 'react';
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

function Product({ product, labels, onPurchase, onRemove }) {

    const Image = ComponentRegistry.get("Image");
    const ImagePlaceholder = ComponentRegistry.get("ImagePlaceholder");

    return (
        <div className="compare-item">
            <div className="inner">
                <div className="product-image">
                    <a className="btn btn-close" href="" onClick={(event) => {
                        event.preventDefault();
                        onRemove();
                    }}><i className="icon icon-close white"></i></a>
                    {product.properties.images.value.length > 0 ? <Image className="img-fluid" src={product.properties.images.value[0].thumb} alt={product.title} /> : <ImagePlaceholder />}
                </div>
                <p>{product.title}</p>
                {/*<div>{product.pricing.excl}</div>*/}
                {/*<a href="" className="btn btn-primary" onClick={(event) => {*/}
                    {/*event.preventDefault();*/}
                    {/*onPurchase();*/}
                {/*}}>{labels.purchase}</a>*/}
            </div>
        </div>
    )
}

function Header({ products, labels, differenceOnly, onDifferenceOnly, onPurchase, onRemove }) {
    return (
        <thead>
            <tr>
                <td>
                    <div>
                        <span className="radio">
                            <input className="radio-input" id="allProperties" type="radio" name="differenceOnly" onChange={event => onDifferenceOnly(false)} />
                            <label className="radio-label" htmlFor="allProperties"> {labels.all_properties}</label>
                        </span>
                    </div>
                    <div>
                        <span className="radio">
                            <input className="radio-input" type="radio" id="differenceOnly" name="differenceOnly" onChange={event => onDifferenceOnly(true)} />
                            <label className="radio-label" htmlFor="differenceOnly"> {labels.difference_only}</label>
                        </span>
                    </div>
                </td>
                {products.map(product => (
                    <td key={product.id}>
                        <Product product={product}
                                 labels={labels}
                                 onRemove={() => onRemove(product)}
                                 onPurchase={() => onPurchase(product)}
                        />
                    </td>
                ))}
            </tr>
        </thead>
    )
}

function PriceRow({ products, matrix, label }) {

    const base = products[0].id;
    return (
        <tr>
            <td>{label}</td>
            {products.map(product => (
                <td key={product.id}>
                    <Price pricing={product.pricing} difference={typeof matrix[base][product.id] !== 'undefined' ? matrix[base][product.id].price : null} originalPricing={product.originalPricing} />
                </td>
            ))}
        </tr>
    );
}

function Price({ pricing, difference, orignalPricing }) {
    return (
        <div>
            {difference !== null?<span className={"label label-"+(difference.excl.indexOf("-") > 0 ? "success" : "danger")}>{difference.excl}</span>:null}
        </div>
    )
}

function PropertyRow({ property, products }) {
     if (products[0].properties[property] !== undefined) {
         return (
             <tr>
                 <td className="text-upper">{products[0].properties[property].name}</td>
                 {products.map(product => (
                     <td key={product.id}>
                         <Property property={product.properties[property]} />
                     </td>
                 ))}
             </tr>)
     } else {
         return null;
     }
}

function Property({ property }) {
    return (
        <div>{typeof property === 'object' ? typeof property.value === 'object' ? property.value.name : property.value : "-"}</div>
    )
}

export default function MatrixView({ properties, products, matrix, labels, differenceOnly, onDifferenceOnly, onPurchase, onRemove }) {
    return (
        <div className="table-responsive">
            <table className="table">
                <Header products={products}
                        labels={labels}
                        differenceOnly={differenceOnly}
                        onDifferenceOnly={onDifferenceOnly}
                        onPurchase={onPurchase}
                        onRemove={onRemove}
                />
                <tbody>
                <PriceRow products={products} matrix={matrix} label={labels.price_difference} />
                {properties
                    .filter(property => {
                        return !differenceOnly || products.some(product => typeof product.properties[property].value  === "object" ?
                                product.properties[property].value.id !== products[0].properties[property].value.id:
                                product.properties[property].value !== products[0].properties[property].value)
                    })
                    .map(property => <PropertyRow key={property} property={property} products={products} />)}
                </tbody>
            </table>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductCompare/Views/MatrixView.jsx